import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const adjustmentRequestRoutes = [
	{
		key: "adjustment-request-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/stock-take/adjustment-requests/list`,
		component: React.lazy(() => import("views/app-views/stock-take/adjustment-requests/pages/AdjustmentRequestList")),
	},
	{
		key: "adjustment-request-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/stock-take/adjustment-requests/create`,
		component: React.lazy(() => import("views/app-views/stock-take/adjustment-requests/pages/AdjustmentRequestForm")),
	},
	{
		key: "adjustment-request-edit",
		exact: true,
		path: `${APP_PREFIX_PATH}/stock-take/adjustment-requests/edit/:id`,
		component: React.lazy(() => import("views/app-views/stock-take/adjustment-requests/pages/AdjustmentRequestForm")),
	},
	{
		key: "adjustment-request-view",
		exact: true,
		path: `${APP_PREFIX_PATH}/stock-take/adjustment-requests/view/:id`,
		component: React.lazy(() => import("views/app-views/stock-take/adjustment-requests/pages/AdjustmentRequestForm")),
	},

];
